import styles from "./Table.module.css"
function Table({ head, body }) {
    return (
        <div className={styles.tableResponsive}>


            <table className={`${styles.fade} ${styles.table}`}>

                <thead>

                    {head}
                </thead>
                <tbody>
                    {body}

                </tbody>
            </table>
        </div>
    )
}
export default Table;